var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("This is an account page")]),_c('Alert',{attrs:{"closable":""}},[_vm._v("mock 请求数据使用的 GET 方法")]),_c('Table',{attrs:{"height":"700","stripe":"","columns":_vm.columns,"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }